import { useEffect } from 'react';

interface ExternalInterface {
    name: string;
    methods: {
        [key: string]: Function;
    };
}

/**
 * This hook can be used to create an interface layer between old and new code.
 * It uses ww global variable that is always defined by old code.
 *
 * @example:
 *
 * useExternalInterface({
 *       name: 'signupLoginABTestApi', // please use unique name to simplify search of the usage in the future
 *       methods: {
 *           getRedirectUrl: () => { implementation },
 *           setRedirectUrl: (arg1) => { implementation },
 *       },
 *  });
 *
 *  //and then in the old codebase you can do
 *
 *  window.signupLoginABTestApi.getRedirectUrl();
 *  window.signupLoginABTestApi.setRedirectUrl(arg1);
 */
const useExternalInterface = (externalInterface: ExternalInterface): void => {
    useEffect(() => {
        window[externalInterface.name] = externalInterface.methods;
        return () => {
            window[externalInterface.name] = null;
        };
    });
};

export default useExternalInterface;
